<template>
  <v-dropdown
    x-placement="top"
    class="dropdown-notifications"
  >
    <div
      slot="label"
      :class="{'new-notifications': hasNotifications}"
    >
      <v-icon
        icon="bell"
        class="cursor-pointer"
        @click.prevent="fetchNotifications"
      />
    </div>

    <div class="w-full m-0 p-0">
      <div
        class="border-b border-grey-light text-black flex text-sm py-2 px-4 flex"
        :style="{'width': '300px'}"
      >
        Notifications
        <a
          v-if="hasNotifications"
          href="#"
          class="ml-auto text-sm text-purple font-semibold"
          @click.prevent="markAllAsRead"
        >Mark all as read</a>
      </div>
      <div
        v-if="hasNotifications"
        :style="{'width': '300px'}"
      >
        <v-notification-item
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
        />
      </div>
      <div
        v-else
        class="p-4 text-sm text-blue-light text-center"
      >
        No notifications yet.
      </div>
    </div>
  </v-dropdown>
</template>

<script>
let notificationsTimeout;

export default {
  name: 'VNotificationDropdown',
  data() {
    return {
      notifications: [],
      isFetchingNotifications: false,
    };
  },
  computed: {
    hasNotifications() {
      return this.notifications.length > 0;
    },
  },
  mounted() {
    this.setupNotificationChecker();
  },
  methods: {
    async setupNotificationChecker() {
      await this.fetchNotifications();
      if (notificationsTimeout) {
        return;
      }
      notificationsTimeout = setInterval(async() => {
        if (this.isFetchingNotifications) {
          return;
        }
        await this.fetchNotifications();
      }, 10 * 60 * 1000); // Every 10 minutes
    },
    async fetchNotifications() {
      this.isFetchingNotifications = true;
      try {
        const response = await this.$api.get('user').fetchNotifications();
        this.notifications = response && response.data || [];
      } catch (e) {
        console.log(e);
      }
      this.isFetchingNotifications = false;
    },
    async markAllAsRead() {
      if (!this.notifications || (this.notifications && this.notifications.length < 1)) {
        return;
      }

      try {
        const ids = this.notifications.map((n) => n.id).join(',');
        this.notifications = [];
        await this.$api.get('user').markAllAsRead({ ids });
      } catch (e) {
        console.log(e);
      }
      await this.fetchNotifications();
    },
  },
};
</script>
